<div class="helper" *ngIf="active">
  <div class="point point1" (click)="toggleHtmlView()"></div>
  <div class="point point2" (click)="toggleSeoClass()"></div>
  <div class="container" [class.visible]="visible">
    seo-helper.component.html
  </div>
</div>
